<mat-expansion-panel [ngClass]="{ 'data-delivery-section-error': form.invalid }">
    <mat-expansion-panel-header class="mat-expasion-header-background">
        <mat-panel-title class="input-text">
            {{ 'ADD_EDIT.ADD_ADVANCED' | translate }}
        </mat-panel-title>
    </mat-expansion-panel-header>
</mat-expansion-panel>
